import { inject, Service } from '@angular/core';
import { GetTraveltimeService } from './services/fetchServices/fetchTraveltime/POST/get-traveltime.service';

@Service()
export class BufferService {

 private traveltimeService = inject(GetTraveltimeService);

//Fahrtzeitberechnung vom vorherigen Termin zum diesem Termin
  async getBufferBefore(event: any, events:any, tempResource: number, currentStart: Date, currentDate: string){
    if(event.calculateTraveltime && this.traveltimeService.calcTraveltimeGlobal){
      const earlierEvents = events.filter((existing: any) => {
              
      let sameResource;
      
      if (!Array.isArray(existing.resource)){
        if(existing.resource === tempResource){
          sameResource = existing.resource;
        }
        
      }else{
        sameResource = existing.resource.some((r: any) => r === tempResource);
      }
      currentStart = new Date(event.start)
      const existingStart = new Date(existing.start);
      const existingDate = existingStart.toISOString().split('T')[0];
      const isSameDay = existingDate === currentDate;
      const isEarlier = existingStart < currentStart;
    
      return sameResource && isSameDay && isEarlier;
      });
          
      const earlierEvent = earlierEvents.sort((a: { start: string | number | Date }, b: { start: string | number | Date }) => new Date(b.start).getTime() - new Date(a.start).getTime())[0];
      let previousEventLocation = earlierEvent?.location || null;
      let eventLocation = event.location

      if(earlierEvent && earlierEvent.type !== 'MISSIONEVENT'){
        previousEventLocation = 'Lina-Bommer-Weg 6, 51149 Köln';
      } 
    
      if(earlierEvent && earlierEvent.online){
        previousEventLocation = 'Lina-Bommer-Weg 6, 51149 Köln';
      } 

      if(earlierEvent === undefined){
        previousEventLocation = 'Lina-Bommer-Weg 6, 51149 Köln';
      } 

      if(event.online){
       eventLocation = 'Lina-Bommer-Weg 6, 51149 Köln';
      }
      
      const bufferBefore = previousEventLocation ? await this.getBuffer(previousEventLocation, eventLocation) : null;

      if(earlierEvent && (earlierEvent.calculateTraveltime || earlierEvent.bufferAfter)){
        const bufferObj = {
          previousEventLocation: previousEventLocation,
          earlierEvent: !!earlierEvent,
          bufferBefore: 0
        }
        return bufferObj
      } else{
        const bufferObj = {
          previousEventLocation: previousEventLocation,
          earlierEvent: !!earlierEvent,
          bufferBefore: bufferBefore
        }
        return bufferObj
      }
    }else{

      const bufferObj = {
        previousEventLocation: '',
        earlierEvent: false,
        bufferBefore: null
     }

      return   bufferObj
    }
  }


  //Fahrtzeitberechnung von diesem Termin zum nächsten Termin
  async getBufferAfter(event: any, events:any, tempResource: number, currentStart: Date, currentDate: string){
    if(event.calculateTraveltime && this.traveltimeService.calcTraveltimeGlobal){
        const nextEvents = events.filter((existing: any) => {

       let sameResource;

        if (!Array.isArray(existing.resource)){
          if(existing.resource === tempResource){
            sameResource = existing.resource;
          }

        }else{
          sameResource = existing.resource.some((r: any) => r === tempResource);
        }
        currentStart = new Date(event.start)
        const existingStart = new Date(existing.start);
        const existingDate = existingStart.toISOString().split('T')[0];
        const isSameDay = existingDate === currentDate;
        const isAfter = existingStart > currentStart;

        return sameResource && isSameDay && isAfter;
        });

      const nextEvent = nextEvents.sort((a: { start: string | number | Date; }, b: { start: string | number | Date; }) => new Date(a.start).getTime() - new Date(b.start).getTime())[0];
      let nextEventLocation = nextEvent?.location || null;
      let eventLocation = event.location
      
      if(nextEvent && nextEvent.type !== 'MISSIONEVENT'){
        nextEventLocation = 'Lina-Bommer-Weg 6, 51149 Köln';
      } 
        
       if(nextEvent && nextEvent.online){
         nextEventLocation = 'Lina-Bommer-Weg 6, 51149 Köln';
       } 

      if(nextEvent === undefined){
        nextEventLocation = 'Lina-Bommer-Weg 6, 51149 Köln';
      } 

       if(event.online){
        eventLocation = 'Lina-Bommer-Weg 6, 51149 Köln';
       }

      const bufferAfter = nextEventLocation ? await this.getBuffer(eventLocation, nextEventLocation) : null;

      const bufferObj = {
        nextEventLocation: nextEventLocation,
        nextEvent: !!nextEvent,
        bufferAfter: bufferAfter
      }

      return bufferObj
    }else{

      const bufferObj = {
        nextEventLocation: '',
        nextEvent: undefined,
        bufferAfter: 0
     }

      return   bufferObj
    }
  }

    //Fahrzeitberechnungsfunktion über Google
    async getBuffer(previousEventLocation: string, eventLocation: string): Promise<number | null> {

      if (previousEventLocation !== '' && eventLocation !== ''){
        try {
          const data = await this.traveltimeService.getBufferBeforeWithGoogle(previousEventLocation, eventLocation);

          if (data) {
            const distance = data.distance // Entfernung
            const duration = data.duration // Minuten

            return duration;
          } else {
            console.warn('Travel data not available or status not OK.');
            return null;
          }
        } catch (error) {

          console.error('Fehler bei getBuffer:', error);
          return null;
        }
      }else{
          return null
        }

    }
}
